import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import "../styles/crick.css";
import IMAGES from "../globals/images";
import STRINGS from "../globals/strings";
import Meta from "./Meta";
import LiveSummary from "../liveMatches/liveSummary";
import LiveScorecard from '../liveMatches/liveScorecard';
import endpoints from '../api/endpoints';
import PopUp from "../components/popUp";

const LivePage = () => {
  const navigate = useNavigate();
  const { matchId, matchType } = useParams();
  // Add this state near the other useState declarations
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [activeTab, setActiveTab] = useState('Scorecard');
  const [activeLink, setActiveLink] = useState('Betting');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedBowler, setSelectedBowler] = useState(null);
  const [matchData, setMatchData] = useState(null);
  const [summaryDataLive, setSummaryDataLive] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();

  const openPopup = (bowler, isSummary = 0, team_name = null) => {
    const bowlerData = {
      bowler_name: bowler.bowler_name || STRINGS.UNKNOWN_BOWLER,
      bowler_id: bowler.bowler_id || "",
      team_name: isSummary === 1 ? team_name : bowler.team_name || ""
    }
    console.log("Opening PopUp with bowler:", bowlerData)
    setSelectedBowler(bowlerData)
    setIsPopupOpen(true)
  }

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedBowler(null);
  };

  const normalizeData = (apiData) => {
    if (!apiData || !Array.isArray(apiData) || apiData.length < 1) {
      return null;
    }

    const team1 = apiData[0] || {};
    const team2 = apiData[1] || {};
    const matchInfo = apiData[2] || {};  // add this

    return {
      team1: {
        batting_team: team1.batting_team_id || "",
        bowling_team: team1.bowling_team_id || "",
        team_name: team1.team_name || "Team 1",
        team_image: team1.team_image || IMAGES.PHOENIX_LOGO,
        inning_total: {
          total_runs: team1.inning_total?.total_runs || 0,
          total_wickets: team1.inning_total?.total_wickets || 0,
          overs: team1.inning_total?.overs || 0,
          match_overs: team1.inning_total?.match_overs || 20,
          extra: {
            total: team1.inning_total?.extra?.total || 0,
            bye: team1.inning_total?.extra?.bye || 0,
            leg_bye: team1.inning_total?.extra?.leg_bye || 0,
            wide_ball: team1.inning_total?.extra?.wide_ball || 0,
            no_ball: team1.inning_total?.extra?.no_ball || 0
          },
          new_target: team1.inning_total?.new_target || 0,
          current_run_rate: team1.inning_total?.current_run_rate || 0,
          is_new_target: team1.inning_total?.is_new_target || 0,
          new_target_info: team1.inning_total?.new_target_info || ""
        },
        batting: team1.batting?.map(b => ({
          batsman_name: b.name || "Unknown",
          total_runs: b.total_runs || 0,
          total_balls: b.total_balls || 0,
          total_fours: b.total_fours || 0,
          total_sixes: b.total_sixes || 0,
          strike_rate: b.strike_rate || 0,
          is_not_out: b.is_not_out || 0,
          out_information: b.out_information || null,
          created_at: b.created_at || null
        })) || [],
        bowling: team1.bowling?.map(b => ({
          bowler_name: b.bowler_first_name && b.bowler_last_name
            ? `${b.bowler_first_name} ${b.bowler_last_name}`.trim()
            : `${b.bowler_first_name}`.trim(),
          total_over: b.total_over || 0,
          total_maiden_over: b.total_maiden_over || 0,
          total_run: b.total_run || 0,
          total_wicket: b.total_wicket || 0,
          economy: b.economy || 0,
          bowler_id: b.bowler_id || "",
          team_name: team1.team_name || "Team 1"
        })) || [],
        fall_of_wicket: team1.fall_of_wicket || [],
        partnership: team1.partnership?.map(p => ({
          batsman_1_name: p.batsman_1_name || "Unknown",
          batsman_1_total_run: p.batsman_1_total_run || 0,
          batsman_1_total_ball: p.batsman_1_total_ball || 0,
          batsman_2_name: p.batsman_2_name || "Unknown",
          batsman_2_total_run: p.batsman_2_total_run || 0,
          batsman_2_total_ball: p.batsman_2_total_ball || 0,
          extra: p.extra || 0,
          score: p.score || 0,
          ball: p.ball || 0
        })) || [],
        over_history: team1.over_history?.map(o => ({
          batsmans_list: o.batsmans_list || "",
          over_number: o.over_number || 0,
          bowler_name: o.bowler_name || "Unknown",
          ball_history: o.ball_history || [],
          total_run_from_over: o.total_run_from_over || 0
        })) || []
      },
      team2: {
        batting_team: team2.batting_team_id || "",
        bowling_team: team2.bowling_team_id || "",
        team_name: team2.team_name || "Team 2",
        team_image: team2.team_image || IMAGES.RED_LIONS_LOGO,
        inning_total: {
          total_runs: team2.inning_total?.total_runs || 0,
          total_wickets: team2.inning_total?.total_wickets || 0,
          overs: team2.inning_total?.overs || 0,
          match_overs: team2.inning_total?.match_overs || 20,
          extra: {
            total: team2.inning_total?.extra?.total || 0,
            bye: team2.inning_total?.extra?.bye || 0,
            leg_bye: team2.inning_total?.extra?.leg_bye || 0,
            wide_ball: team2.inning_total?.extra?.wide_ball || 0,
            no_ball: team2.inning_total?.extra?.no_ball || 0
          },
          new_target: team2.inning_total?.new_target || 0,
          current_run_rate: team2.inning_total?.current_run_rate || 0,
          is_new_target: team2.inning_total?.is_new_target || 0,
          new_target_info: team2.inning_total?.new_target_info || ""
        },
        batting: team2.batting?.map(b => ({
          batsman_name: b.name || "Unknown",
          total_runs: b.total_runs || 0,
          total_balls: b.total_balls || 0,
          total_fours: b.total_fours || 0,
          total_sixes: b.total_sixes || 0,
          strike_rate: b.strike_rate || 0,
          is_not_out: b.is_not_out || 0,
          out_information: b.out_information || null,
          created_at: b.created_at || null
        })) || [],
        bowling: team2.bowling?.map(b => ({
          bowler_name: b.bowler_first_name && b.bowler_last_name
            ? `${b.bowler_first_name} ${b.bowler_last_name}`.trim()
            : `${b.bowler_first_name}`,
          total_over: b.total_over || 0,
          total_maiden_over: b.total_maiden_over || 0,
          total_run: b.total_run || 0,
          total_wicket: b.total_wicket || 0,
          economy: b.economy || 0,
          bowler_id: b.bowler_id || "",
          team_name: team2.team_name || "Team 2"
        })) || [],
        fall_of_wicket: team2.fall_of_wicket || [],
        partnership: team2.partnership?.map(p => ({
          batsman_1_name: p.batsman_1_name || "Unknown",
          batsman_1_total_run: p.batsman_1_total_run || 0,
          batsman_1_total_ball: p.batsman_1_total_ball || 0,
          batsman_2_name: p.batsman_2_name || "Unknown",
          batsman_2_total_run: p.batsman_2_total_run || 0,
          batsman_2_total_ball: p.batsman_2_total_ball || 0,
          extra: p.extra || 0,
          score: p.score || 0,
          ball: p.ball || 0
        })) || [],
        over_history: team2.over_history?.map(o => ({
          batsmans_list: o.batsmans_list || "",
          over_number: o.over_number || 0,
          bowler_name: o.bowler_name || "Unknown",
          ball_history: o.ball_history || [],
          total_run_from_over: o.total_run_from_over || 0
        })) || [],
        result: team2.result || null
      },
      matchSettings: {                              // add this block
        is_no_ball_allowed: matchInfo.is_no_ball_allowed ?? 0,
        is_wide_ball_allowed: matchInfo.is_wide_ball_allowed ?? 0,
      },
      playerOfMatch: {
        name: summaryDataLive?.player_of_match?.name || "Unknown",
        team: summaryDataLive?.player_of_match?.team_name || "Team 1",
        image: summaryDataLive?.player_of_match?.profile_picture || IMAGES.KUNAL
      },
      best_batter: team1.batting?.[0] || team2.batting?.[0] || null,
      best_bowler: team1.bowling?.[0] || team2.bowling?.[0] || null
    };
  };

  useEffect(() => {
    fetchScorecard();
    fetchSummaryDataLive();
  }, [matchId, matchType]);

  const fetchScorecard = async () => {
    if (!matchId || !matchType) {
      setError(STRINGS.INVALID_MATCH_ID_TYPE);
      setMatchData(null);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const data = await endpoints.fetchScorecard(matchId, matchType);
      if (data.success && data.data && Array.isArray(data.data) && data.data.length > 0) {
        const normalizedData = normalizeData(data.data);
        if (
          !normalizedData ||
          (!normalizedData.team1.inning_total.total_runs &&
            !normalizedData.team1.inning_total.total_wickets &&
            !normalizedData.team1.inning_total.overs &&
            !normalizedData.team2.inning_total.total_runs &&
            !normalizedData.team2.inning_total.total_wickets &&
            !normalizedData.team2.inning_total.overs)
        ) {
          setError(STRINGS.NO_SCORECARD_DATA);
          setMatchData(null);
        } else {
          // ✅ KEY FIX: Just update matchData, never touch selectedTeam here.
          // LiveScorecard manages its own selectedTeam internally.
          setMatchData(normalizedData);
          setSelectedTeam(prev => prev ?? normalizedData?.team1?.team_name);
        }
      } else {
        console.error(`Invalid or empty Scorecard API data for match_type: ${matchType}:`, data);
        setError(STRINGS.NO_SCORECARD_DATA);
        setMatchData(null);
      }
    } catch (err) {
      console.error(`Scorecard API Error for match_type: ${matchType}:`, err.message);
      setError(`${STRINGS.FAILED_TO_FETCH_SCORECARD}${err.message}`);
      setMatchData(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchSummaryDataLive = async () => {
    try {
      const data = await endpoints.fetchSummaryDataLive(matchId, matchType);
      setSummaryDataLive(data.data || {});
    } catch (err) {
      setError(`${STRINGS.FAILED_TO_FETCH_SUMMARY}${err.message}`);
    }
  };

  const pathParts = location.pathname.split("/");
  const routeMatchType = pathParts[3];

  const isQuickMatch = routeMatchType === "qm";

  const googlePlayUrl = isQuickMatch
    ? STRINGS.GOOGLE_PLAY_URL_BOTTOM
    : STRINGS.GOOGLE_PLAY_URL_BOTTOM;

  const appStoreUrl = isQuickMatch
    ? STRINGS.APP_STORE_URL_BOTTOM
    : STRINGS.APP_STORE_URL_BOTTOM;

  const imageClick = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const handleLinkClick = (link, e) => {
    e.preventDefault();
    setActiveLink(link);
  };

  const formatOutInfo = (batterInfo) => {
    let outInfo = "";

    if (batterInfo?.is_not_out === 1) {
      return "not out";
    }

    if (batterInfo?.out_information) {
      const info = batterInfo.out_information;

      switch (info.out_type) {
        case "CatchOut":
          if (info.ball_by === info.out_by) {
            outInfo = `c & b ${info.ball_by || ""}`;
          } else {
            outInfo = `c ${info.out_by || ""} b ${info.ball_by || ""}`;
          }
          break;

        case "BowledOut":
          outInfo = `b ${info.ball_by || ""}`;
          break;

        case "StOut":
          outInfo = `st ${info.out_by || ""}`;
          break;

        case "RunOut": {
          let outText = "";
          if (info.out_by) {
            outText = `run out (${info.out_by})`;
          }
          if (info.out_by_2) {
            outText = outText
              ? `Run Out (${info.out_by} - ${info.out_by_2})`
              : `run out (${info.out_by_2})`;
          }
          outInfo = outText || "run out";
          break;
        }

        case "HitWicket":
          outInfo = `hit wicket b ${info.ball_by || ""}`;
          break;

        case "RetiredOut":
          outInfo = `RetiredHurt`;
          break;

        case "LBWOut":
          outInfo = `lbw b ${info.ball_by || ""}`;
          break;

        default:
          outInfo = "";
      }
    }

    return outInfo;
  };

  return (
    <div className='app-container'>
      <Meta />
      <div className='header'>
        <div>
          <img src={IMAGES.BACKARROW} alt={STRINGS.PLAYER_LOGO_ALT} className="back-arrow" onClick={() => navigate(-1)} />
          <img src={IMAGES.LOGO} alt={STRINGS.CRICKSTAR_LOGO_ALT} className="logo" />
        </div>
        <div className='live-match-right'>
          <img
            src={IMAGES.LIVEMATCH}
            alt={STRINGS.PLAYER_LOGO_ALT}
            className='live-button'
          />
          <img
            src={IMAGES.REFRESH}
            alt={STRINGS.PLAYER_LOGO_ALT}
            className='refresh-button'
            onClick={() => { fetchScorecard(); fetchSummaryDataLive(); }}
          />
        </div>
      </div>
      <div className='main-content'>
        <div className="left-banner">
          <div className="banner-content">
            <img src={IMAGES.LEFT_BANNER} alt={STRINGS.LEFT_BANNER_ALT} className="banner-logo" />
            <div className="left-buttons" style={{ cursor: "pointer" }}>
              <img
                src={IMAGES.GOOGLE_PLAY}
                alt={STRINGS.GOOGLE_PLAY_ALT}
                className="left-button"
                onClick={() => imageClick(STRINGS.GOOGLE_PLAY_URL_LEFT)}
              />
              <img
                src={IMAGES.APP_STORE}
                alt={STRINGS.APP_STORE_ALT}
                className="left-button"
                onClick={() => imageClick(STRINGS.APP_STORE_URL_LEFT)}
              />
            </div>
          </div>
        </div>
        <div className="middle-section">
          {loading ? (
            <div className="loading-spinner">...Loading...</div>
          ) : error || !matchData ? (
            <div>{error || STRINGS.NO_DATA_FOUND}</div>
          ) : (
            <>
              <div className="tabs">
                <div
                  className="transporter"
                  style={{ transform: `translateX(${activeTab === "Summary" ? 0 : 100}%)` }}
                ></div>
                <button
                  className={`tab ${activeTab === "Summary" ? "active" : ""}`}
                  onClick={() => setActiveTab("Summary")}
                >
                  {STRINGS.SUMMARY_TAB}
                </button>
                <button
                  className={`tab ${activeTab === "Scorecard" ? "active" : ""}`}
                  onClick={() => setActiveTab("Scorecard")}
                >
                  {STRINGS.SCORECARD_TAB}
                </button>
              </div>

              {activeTab === "Summary" && (
                <LiveSummary
                  summaryDataLive={summaryDataLive}
                  openPopup={openPopup}
                />
              )}

              {activeTab === "Scorecard" && (
                <LiveScorecard
                  matchSettings={matchData.matchSettings}   // add this
                  activeLink={activeLink}
                  handleLinkClick={handleLinkClick}
                  openPopup={openPopup}
                  activeTab={activeTab}
                  matchData={matchData}
                  formatOutInfo={formatOutInfo}
                  selectedTeam={selectedTeam}
                  setSelectedTeam={setSelectedTeam}
                />
              )}
            </>
          )}
        </div>
        <div className="right-ad-section">
          <div className="right-ad">
            <img src={IMAGES.RIGHT_BANNER} alt={STRINGS.RIGHT_BANNER_ALT} className="right-banner-image" />
            <div className="ad-content">
              <div className="ad-text-group">
                <h2 className="ad-title">{STRINGS.AD_TITLE}</h2>
                <p className="ad-subtitle">{STRINGS.AD_SUBTITLE}</p>
              </div>
              <div className="store-buttons" style={{ cursor: "pointer" }}>
                <img
                  src={IMAGES.GOOGLE_PLAY}
                  alt={STRINGS.GOOGLE_PLAY_ALT}
                  className="store-button"
                  onClick={() => imageClick(STRINGS.GOOGLE_PLAY_URL_RIGHT)}
                />
                <img
                  src={IMAGES.APP_STORE}
                  alt={STRINGS.APP_STORE_ALT}
                  className="store-button"
                  onClick={() => imageClick(STRINGS.APP_STORE_URL_RIGHT)}
                />
              </div>
            </div>
          </div>
          <div className="bottom-banner">
            <img src={IMAGES.BOTTOM_BANNER} alt={STRINGS.BOTTOM_BANNER_ALT} className="bottom-banner-image" />
            <div className="bottom-buttons" style={{ cursor: "pointer" }}>
              <img
                src={IMAGES.GOOGLE_PLAY}
                alt={STRINGS.GOOGLE_PLAY_ALT}
                className="bottom-button"
                onClick={() => imageClick(googlePlayUrl)}
              />
              <img
                src={IMAGES.APP_STORE}
                alt={STRINGS.APP_STORE_ALT}
                className="bottom-button"
                onClick={() => imageClick(appStoreUrl)}
              />
            </div>
          </div>
        </div>
      </div>
      {isPopupOpen && (
        <div className="modal-overlay" onClick={closePopup}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <PopUp bowler={selectedBowler} onClose={closePopup} matchId={matchId} matchType={matchType} />
          </div>
        </div>
      )}
    </div>
  );
};

export default LivePage;